export default "__VITE_ASSET__CLjeKGOT__"